import { Container, Row, Col } from 'react-bootstrap';

const OurValues = () => {
    return (
        <section className="bg-primary py-5 our-values-section">
            <Container>
                <h2 className="text-center mb-5 text-white">Our Values</h2>
                <Row className="justify-content-center">
                    <Col xs={12} sm={6} lg={3} className="mb-3">
                        <div className="white-card text-center px-3 pt-4">
                            <div className="text-primary mb-2 ft-24 ft-wt-700">Excellent Customer Service</div>
                            <p className="text-primary">
                                We help customers achieve their business objectives by consistently delivering best in class services and exceeding expectations.
                            </p>
                        </div>
                    </Col>
                    <Col xs={12} sm={6} lg={3} className="mb-3">
                        <div className="blue-card text-center px-3 pt-4">
                            <div className="text-white mb-2 ft-24 ft-wt-700">Integrity, Trust, and Transparency</div>
                            <p className="text-white">
                                Honest communication internally and with our clients is key. We will be with you at each development phase of your project, and ensure there are no surprise fees for the work quoted.
                            </p>
                        </div>
                    </Col>
                    <Col xs={12} sm={6} lg={3} className="mb-3">
                        <div className="white-card text-center px-3 pt-4">
                            <div className="text-primary mb-2 ft-24 ft-wt-700">Respect for the individual</div>
                            <p className="text-primary">
                                We believe in the capability of each person and provide a safe environment for each individual to grow and realize their potential.
                            </p>
                        </div>
                    </Col>
                    <Col xs={12} sm={6} lg={3} className="mb-3">
                        <div className="blue-card text-center px-3 pt-4">
                            <div className="text-white mb-2 ft-24 ft-wt-700">Commitment to excellence</div>
                            <p className="text-white">
                                We are 100% dedicated to delivering high-quality work by being innovative, dedicated, and entrepreneurial. Your business success is our main goal.
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default OurValues;
